import Vue from 'vue'
import { i18n, sprintf, getBDTimezone } from '@/common/utils/i18n'
import {
  BIZOPP_RANK_OPTIONS,
  BIZOPP_STATUS_OPTIONS,
  BIZDAY_OPTIONS,
  BIZDAY_GAS_OPTIONS,
} from '@/consts'
import { url2localProtocol, imageCut } from '@/common/utils/util'
import { getFormatTimeByPatternAndTimezone } from '@didi/elvish-lib-javascript'

export default function initGlobalFilters() {
  // 商机价值等级转换
  Vue.filter('bizoppRank2word', value => {
    return sprintf(
      i18n.gettext('%s级'),
      (BIZOPP_RANK_OPTIONS.find(i => i.value === value) || {}).label,
    )
  })
  // 门店状态
  Vue.filter('bizoppStatus2word', ({ status, contractorStatus }) => {
    return (BIZOPP_STATUS_OPTIONS.find(i => i.value === status) || {}).label
  })
  // url转为本地的协议
  Vue.filter('url2localProtocol', (url = '') => {
    return url2localProtocol(url)
  })
  // 图片资源加入图床裁剪
  Vue.filter('imageCut', (url = '', ratio, isEqual) => {
    return imageCut(url, ratio, isEqual)
  })
  // 距离
  Vue.filter('formatDistance', value => {
    if (value < 1000) {
      return Math.round(value) + 'm'
    } else if (value <= 50000) {
      return (value / 1000).toFixed(1) + 'km'
    } else {
      return Math.round(value / 1000) + 'km'
    }
  })
  Vue.filter('formatTime', value => {
    // 历史原因，按照浏览器所在时区展示
    return getFormatTimeByPatternAndTimezone(getBDTimezone(), value, 'yyyy-MM-dd HH:mm:ss')
  })
  // 营业时间-天数
  Vue.filter('formatBizDay', value => {
    return value
      .map(i => {
        return (BIZDAY_OPTIONS.find(j => j.value === i) || {}).label
      })
      .join(',')
  })
  // 营业时间-天数
  Vue.filter('formatGasBizDay', value => {
    return value
      .map(i => {
        return (BIZDAY_GAS_OPTIONS.find(j => j.value === i) || {}).label
      })
      .join(',')
  })
}
